import { Instagram, Facebook, Youtube, ArrowUpRight } from "lucide-react";
import { useLang } from "../../i18n";
import { useContent } from "../../lib/useContent";
import { Reveal, SectionHeading } from "../Reveal";

export default function SocialSection() {
  const { pick } = useLang();
  const c = useContent();
  const cards = [
    {
      key: "instagram", icon: Instagram, name: "Instagram", handle: "@ananshawelfaresociety",
      url: c.social.instagram, testid: "social-card-instagram",
      bg: "bg-gradient-to-br from-[#833AB4] via-[#FD1D1D] to-[#F77737]",
      cta: pick({ hi: "Instagram पर फॉलो करें", en: "Follow on Instagram" }),
      desc: pick({ hi: "हमारी गतिविधियों की ताज़ा फोटो और रील्स देखें।", en: "See the latest photos and reels of our activities." }),
    },
    {
      key: "facebook", icon: Facebook, name: "Facebook", handle: "Anansha Welfare Society",
      url: c.social.facebook, testid: "social-card-facebook",
      bg: "bg-[#1877F2]",
      cta: pick({ hi: "Facebook पर फॉलो करें", en: "Follow on Facebook" }),
      desc: pick({ hi: "अभियानों और कार्यक्रमों की अपडेट पाएं।", en: "Get updates on campaigns and events." }),
    },
    {
      key: "youtube", icon: Youtube, name: "YouTube", handle: "@AnanshaWelfareSociety-007",
      url: c.social.youtube, testid: "social-card-youtube",
      bg: "bg-[#FF0000]",
      cta: pick({ hi: "YouTube पर सब्सक्राइब करें", en: "Subscribe on YouTube" }),
      desc: pick({ hi: "हमारे कार्यों के वीडियो देखें।", en: "Watch videos of our work." }),
    },
  ].filter((x) => x.url);

  if (!cards.length) return null;

  return (
    <section data-testid="social-section" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHeading
          overline={pick({ hi: "सोशल मीडिया", en: "Social Media" })}
          title={pick({ hi: "हमसे जुड़ें सोशल मीडिया पर", en: "Connect With Us on Social Media" })}
          description={pick({ hi: "हमारी रोज़ की गतिविधियां, फोटो और वीडियो — सीधे हमारे आधिकारिक पेजों पर।", en: "Our daily activities, photos and videos — directly on our official pages." })}
          testid="social-section-heading"
        />
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((s, i) => (
            <Reveal key={s.key} i={i}>
              <a
                data-testid={s.testid}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group block h-full bg-ngo-cream rounded-3xl border border-ngo-deep/10 p-8 hover:-translate-y-1.5 hover:shadow-[0_20px_50px_rgba(23,107,58,0.14)] transition-[box-shadow,transform] duration-300"
              >
                <div className={`w-14 h-14 rounded-2xl ${s.bg} text-white flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                  <s.icon size={26} />
                </div>
                <h3 className="mt-5 font-heading font-bold text-xl text-ngo-ink">{s.name}</h3>
                <p className="text-xs text-ngo-ink/50 mt-1">{s.handle}</p>
                <p className="mt-3 text-sm text-ngo-ink/65 leading-relaxed">{s.desc}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-bold text-ngo-deep group-hover:gap-2.5 transition-[gap] duration-200">
                  {s.cta} <ArrowUpRight size={15} />
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
